<template>
  <div>
    <div class="echarts" :style="`padding: 2px; margin-top: 20px; border-radius: 10px; height: ${height}`">
      <v-chart v-if="show" :option="options" :resizable="true" @datazoom="zoomCallback"></v-chart>
    </div>
    <div style="text-align: left">
      <span style="font-size: 0.8em; font-weight: bold; padding: 5px;
            border-radius: 5px; background-color: rgba(220, 220, 220, 0.8);
            margin-left: 45px;">
        Date Range Filter
      </span>
    </div>
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'
import IEcharts from 'vue-echarts-v3/src/full.js'

const _ = require('lodash')

export default {
  name: 'VariantDataCladeTimelineScatter',
  data() {
    return { 
      store: store,
      show: false, 
      basicChartOptions: {
        textStyle: { fontFamily: store.theme.fontFamily.content, fontWeight: 'bold', color: '#2F7780'},
        cursor: 'default',
        grid: [ 
          { height: 50, top: 60, left: 45, right: 20 },
          { top: 160, bottom: 100, left: 45, right: 20 }, 
        ],
        tooltip: {
          show: true,
          trigger: 'axis', axisPointer: { type: 'line', axis: 'x' },
          backgroundColor: 'rgba(250 , 250, 250, 1)',
          borderColor: '#bebebe', borderWidth: 1,
          padding: 10, appendToBody: true,
          textStyle: { color: '#5e5e5e', fontFamily: store.theme.fontFamily.plotTooltip, fontWeight: 'normal' },
        },
        axisPointer: {
          link: { xAxisIndex: [0, 1] },
          label: { backgroundColor: '#777' }
        },
        toolbox: {
          top: 0, itemSize: 15,
          feature: {  
            saveAsImage: { 
              title: 'Save as PNG', show: true, type: 'png', 
              name: 'GenomeCladeTimeline', excludeComponents: ['toolbox', 'dataZoom'],
            },
            restore: { title: 'Restore' },
          }
        },
        dataZoom: [
          {
            type: 'inside', xAxisIndex: [0,1], realtime: false
          },{  
            type: 'slider', xAxisIndex: [0,1],
            height: 25, bottom: 10,
            filterMode: 'filter', rangeMode: ['value', 'value'],
            backgroundColor: 'rgba(233, 71, 49, 0)',
            borderColor: 'rgba(0,0,0,0.2)',
            dataBackground: {
              lineStyle: { shadowColor: '#2F7780', opacity: 0 },
              areaStyle: { color: 'blue', shadowColor: '#4e4e4e', opacity: 0 }
            }, realtime: false,
            fillerColor: 'rgba(150, 150, 150, 0.3)',
            handleIcon: 'M 19 0 L 19 23 L 7.6875 23 L 11.28125 19.40625 C 11.875 18.832031 12.054688 17.957031 11.734375 17.195313 C 11.417969 16.4375 10.667969 15.949219 9.84375 15.96875 C 9.320313 15.988281 8.828125 16.214844 8.46875 16.59375 L 1.46875 23.59375 L 0.03125 25 L 1.46875 26.40625 L 8.46875 33.40625 C 8.949219 34.003906 9.726563 34.273438 10.472656 34.101563 C 11.222656 33.929688 11.804688 33.347656 11.976563 32.597656 C 12.148438 31.851563 11.878906 31.074219 11.28125 30.59375 L 7.6875 27 L 19 27 L 19 50 L 23 50 L 23 0 Z M 27 0 L 27 50 L 31 50 L 31 27 L 42.34375 27 L 38.75 30.59375 C 38.230469 31.097656 38.023438 31.84375 38.210938 32.542969 C 38.398438 33.242188 38.949219 33.785156 39.648438 33.964844 C 40.351563 34.144531 41.09375 33.929688 41.59375 33.40625 L 50 25 L 41.59375 16.59375 C 41.21875 16.199219 40.699219 15.972656 40.15625 15.96875 C 40.09375 15.964844 40.03125 15.964844 39.96875 15.96875 C 39.183594 16.035156 38.511719 16.550781 38.25 17.292969 C 37.984375 18.035156 38.183594 18.863281 38.75 19.40625 L 42.34375 23 L 31 23 L 31 0 Z',
            handleSize: '80%',
            handleStyle: { color: '#2F7780', },
            textStyle: { color: '#2F7780', },
        }],
        yAxis: [
          { 
            data:['India'], gridIndex: 0, name: 'Country', 
            nameTextStyle: { fontSize: 16, color: '#FF8500', align: 'center',
            padding: [ 0, 0, -10, 0 ] }, 
            axisLabel: { 
              show: true, 
              formatter: function(val) { 
                if (val.length > 10) { return val.slice(0, 6) + '...'} 
                else { return val }
              },
            },
            axisLine: { lineStyle: { color: '#2F7780' }},
          }, {
            gridIndex: 1, name: 'State', 
            nameTextStyle: { 
              fontSize: 16, color: '#FF8500', align: 'center',padding: [0,0,-10,0]
            },
            axisLine: { lineStyle: { color: '#2F7780' }},
            splitLine: { show: true, lineStyle: { color: "#2F7780" } },
          }
        ],
        xAxis: [
          {
            type: 'time', gridIndex: 0,
            axisLine: { show: false }, axisLabel: { show: false },
            axisTick: {show: false},
            splitLine: { 
              show: true, opacity: 0.5,
              lineStyle: { color: '#2F7780', type: 'dotted' },
            },
          },{
            type: 'time', gridIndex: 1,
            name: 'Date', nameLocation: 'center', nameGap: 35,
            axisLabel: { show: true },
            axisLine: { lineStyle: { color: '#2F7780' } },
            axisTick: { interval: 0, lineStyle: { color: '#2F7780' } },
            nameTextStyle: { fontSize: 16, color: '#FF8500' },
            splitLine: { 
              show: true, opacity: 0.5,
              lineStyle: { color: '#2F7780', type: 'dotted' },
            },
          }
        ],
        legend: { 
          show: true, type: 'scroll', left: 5, top: 0, width: '70%',
          textStyle: { color: '#2F7780', fontSize: 14, fontWeight: 'bold' },
        },
        resize: true,
      }, 
      numSamples: 0,
      totalSamples: 0,
      startDate: 0, stopDate: 0,
      dates: [],
    }
  },
  components: {
    'v-chart': IEcharts,
  },
  props: {
    plotdata: Array,
    initialZoom: {
      type: Number,
      default: 0
    },
    initialZoomEnd: {
      type: Number,
      default: 100
    },
    index: Number,
    top: { 
      type: Number,
      default: 5
    }
  },
  mounted() { 
    const context = this
    context.show = true
    context.zoomCallback({ start: context.initialZoom, end: context.initialZoomEnd })
  },
  methods: {
    loadChart: function() {
      
      
    },
    zoomCallback: function(val){
      let startVal = 0;
      let endVal = 0;
      if (val.batch === undefined) {
        startVal = val.start; endVal = val.end;
      } else {
        startVal = val.batch[0].start; endVal = val.batch[0].end;        
      }
      const context = this
      const diff = context.stopDate - context.startDate
      const start = Math.round(context.startDate + (diff*startVal)/100)
      const end = Math.round(context.startDate + (diff*endVal)/100)
      context.numSamples = _.filter(context.dates, d => {
        return (d >= start) && (d <= end);
      }).length
    }
  },
  computed: {
    height: function() {
      return `${(40*(this.top+1)) + 200}px`
    },
    options: function() {
      const context = this
      const plotdata = context.plotdata

      const states = _.uniq(_.map(plotdata, 'state'))

      let topStates = []
      let otherStates = []
      let plotOthers = false
      const statesSorted = _.sortBy(states, s => {
        const count = parseInt(_.sumBy(_.filter(plotdata, p => { return p.state === s }), 'count'))
        return -1*count
      })
      if (context.top < states.length) {
        plotOthers = true
        for (let i=0; i<context.top; i++) topStates.push(statesSorted[i])
        for (let i=context.top; i<statesSorted.length; i++) otherStates.push(statesSorted[i])
      } else {
        topStates = _.map(statesSorted, s => { return s })
      }
      topStates.reverse()
      const indianStates = store.constants.indianStates
      
      const stateCodes = {}
      indianStates.forEach(s => { stateCodes[s.name] = s.code })
      stateCodes['India'] = 'IN'
      const clades = _.uniq(_.map(plotdata, 'clade'))
      const dates = _.map(plotdata, d => { return Date.parse(d.date) })
      context.dates = dates
      const startDate = _.min(dates); context.startDate = startDate
      const stopDate = _.max(dates); context.stopDate = stopDate
      
      const series = []

      clades.forEach(c => {
        const cladeData = _.filter(plotdata, d => { return d.clade == c })
        const cladeDates = _.uniq(_.map(cladeData, 'date')); cladeDates.sort()
        const cladeCountryPlotData = _.map(cladeDates, d => { 
          const n = _.sumBy(_.filter(cladeData, o => { return o.date == d; }), 'count')
          return [ d.split('-').join('/'), 'India', n] 
        })

        series.push({
          type: 'scatter', name: c, 
          xAxisIndex: 0, yAxisIndex: 0, data: cladeCountryPlotData,
          symbolSize: function(d) { return 5 + 5*Math.log2(d[2]) },
          itemStyle: { opacity: 0.7}, color: store.theme.colors.clades[c]
        })
        
        const cladeStates = _.uniq(_.map(cladeData, 'state'))
        let cladeStatePlotData = []
        const otherPlotData = []
        cladeStates.forEach( s => {
          const cladeStateDateCounts = _.filter(cladeData, d => { return d.state === s } )
          const cladeStateDates = _.uniq(_.map(cladeStateDateCounts, 'date'))
          
          if ( topStates.indexOf(s) === -1 ) {
            cladeStateDates.forEach( d => {
              const modDate = d.split('-').join('/')
              let dateFound = false
              const count = _.filter(cladeStateDateCounts, s => { return s.date == d })[0]['count']
              for (let i=0; i < otherPlotData.length; i++) {
                if (otherPlotData[i][0] === modDate) {
                  dateFound = true
                  otherPlotData[i][2] += count
                }
              }
              if (!dateFound) {
                otherPlotData.push([ modDate, 'Others', count])
              }
            })
          } else {
            cladeStateDates.forEach(d => {
              const modDate = d.split('-').join('/')
              const count = _.filter(cladeStateDateCounts, s => { return s.date == d })[0]['count']
              cladeStatePlotData.push([modDate, s, count])
            })
          }
        })

        series.push({
          type: 'scatter', name: c, data: cladeStatePlotData, // cladePlotData.slice(0, cladePlotData.length),
          xAxisIndex: 1, yAxisIndex: 1,
          symbolSize: function(d) { return 5 + 3*Math.log2(d[2]) },
          itemStyle: { opacity: 0.7}, color: store.theme.colors.clades[c]
        })
        if ( otherPlotData.length > 0 ) {
          series.push({
            type: 'scatter', name: c, data: otherPlotData, // cladePlotData.slice(0, cladePlotData.length),
              xAxisIndex: 1, yAxisIndex: 1,
              symbolSize: function(d) { return 5 + 3*Math.log2(d[2]) },
              itemStyle: { opacity: 0.7}, color: store.theme.colors.clades[c]
          })
        }
      })


      const options = Object.assign({}, context.basicChartOptions)
      options.dataZoom[0].start = context.initialZoom
      options.dataZoom[1].start = context.initialZoom
      options.dataZoom[1].top = (40*(topStates.length+1)) + 165
      options.yAxis[1].data = (plotOthers) ? ['Others'].concat(topStates) : [...topStates]
      options.xAxis[0].min = startDate - 172800000
      options.xAxis[0].max = stopDate + 172800000
      options.xAxis[1].min = startDate - 172800000
      options.xAxis[1].max = stopDate + 172800000
      options.yAxis[1].axisLabel = { 
        show: true,
        formatter: function(val) {
          if (val === 'Others') { return 'Other' }
          else {  return stateCodes[val] }
        }, color: '#4e4e5e'
      },
      options.legend.data = _.sortBy(_.map(clades, c => {
        return { name: c, icon: 'circle', color: store.theme.colors.clades[c] } 
      }), 'name')
      options.series = series
      return options
    }
  }
}
</script>